import React from 'react';
import './style/app.scss';
import About from './components/about/About';
import Privacy from './components/privacy/Privacy';
import FAQ from './components/faq/FAQ';
import Landing from './components/landing-page/Landing';
import Solutions from './components/solutions/Solutions';
import Pricing from './components/pricing/Pricing';
import Footer from './components/footer/Footer';
import Integrations from './components/integrations/Integrations';
import { Route, Routes, Outlet, Navigate } from 'react-router-dom';


function App() {
    return (
      <div className='site'>
        <main style={{flex: 1}}>
            <app-toast aria-live="polite" aria-atomic="true"></app-toast>
            <Routes>
              <Route path='/' element={<Landing />}/>
              <Route path='/about' element={<About />}/>
              <Route path='/privacy' element={<Privacy />}/>
              <Route path='/faq' element={<FAQ />}/>
              <Route path='/pricing' element={<Pricing />}/>
              <Route path='/solutions' element={<Solutions />}/>
              <Route path='/integrations' element={<Integrations />}/>
              <Route path="*" element={<Navigate to="/" />}/>
            </Routes>
            <Outlet />
        </main>
        <Footer />
    </div>
    );
}

export default App;
